import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22custom-fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/RecifeText-SemiBold.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/RecifeText-SemiBoldItalic.woff2%22,%22weight%22:%22600%22,%22style%22:%22italic%22}],%22variable%22:%22--custom-font-recife-text%22,%22preload%22:false}],%22variableName%22:%22recifeText%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'recifeText', 'recifeText Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
